/*
 *  LayoutHeader.tsx
 * This Component is used to manage menu functionality in a single header and we'll use it all over the project.
 */

import UserProfile from "./user-profile";
import styles from "./layout-header.module.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Text, { LanguageContext } from "../../context/language-context";
import { useContext } from "react";
import { Dropdown, Menu, Button } from "antd";
import { FaUser } from "react-icons/fa";
import AuthUtil from "../../utils/auth";
import useDrawer from "../../hooks/useDrawer";
import { DrawerOpen } from "../../state/drawer/slice";
import TimelineForm from "./timeline-form";
import AddAdminDrawer from "./add-admin";
import { UserContext } from "../../context";
import { eUserType } from "../../utils/enum";

type TProps = {
  onToggleSideBar?: Function;
  sideBarStatus?: boolean;
  isAuthLayout?: boolean;
};

const langOptions = [
  {
    label: "English",
    value: "en",
  },
  {
    label: "हिन्दी",
    value: "hi",
  },
  // {
  //   label: "संस्कृतम्",
  //   value: "sk",
  // },
];

export default function LayoutHeader(props: TProps) {
  const { userLanguage, userLanguageChange } = useContext(LanguageContext);
  const navigate = useNavigate();
  const location = useLocation();
  const { onShowDrawer } = useDrawer();
  const userData = useContext(UserContext);

  const handleEditTimeline = () => {
    onShowDrawer({
      dimmer: true,
      width: window.innerWidth <= 768 ? "100%" : "60%",
      name: "Timeline Form",
      Component: () => <TimelineForm />,
      position: DrawerOpen.right,
    });
  };

  const handleAddAdminDrawer = () => {
    onShowDrawer({
      dimmer: true,
      width: window.innerWidth <= 768 ? "100%" : "30%",
      name: "Add Admin Form",
      Component: () => <AddAdminDrawer />,
      position: DrawerOpen.right,
    });
  };

  const handleProfileDrawer = () => {
    onShowDrawer({
      dimmer: true,
      width: window.innerWidth <= 768 ? "100%" : "30%",
      name: "Profile",
      Component: () => <UserProfile />,
      position: DrawerOpen.right,
    });
  };

  const { dictionary } = useContext(LanguageContext);

  const menu = (
    <Menu>
      <Menu.Item key="profile" onClick={() => handleProfileDrawer()}>
        {dictionary["PROFILE"] || "Profile"}
      </Menu.Item>
      <Menu.Item
        key="my-applications"
        onClick={() => navigate("/my-applications")}
      >
        {dictionary["MY_APPLICATIONS"] || "My Applications"}
      </Menu.Item>
      {location.pathname === "/admin/dashboard" && (
        <Menu.Item key="edit-timeline" onClick={() => handleEditTimeline()}>
          {dictionary["EDIT_TIMELINE"] || "Edit Timeline"}
        </Menu.Item>
      )}
      {location.pathname === "/admin/dashboard" && (
        <Menu.Item key="home" onClick={() => navigate("/dashboard")}>
          {dictionary["USER_DASHBOARD"] || "User Dashboard"}
        </Menu.Item>
      )}
      {userData.user?.userType === eUserType.ADMIN &&
        (location.pathname === "/dashboard" ||
          location.pathname === "/my-applications") && (
          <Menu.Item
            key="admin-dashboard"
            onClick={() => navigate("/admin/dashboard")}
          >
            {dictionary["ADMIN_DASHBOARD"] || "Admin Dashboard"}
          </Menu.Item>
        )}
      <Menu.Item
        key="logout"
        onClick={() => {
          AuthUtil.logout();
        }}
      >
        {dictionary["LOGOUT"] || "Logout"}
      </Menu.Item>
    </Menu>
  );

  return (
    <div className={styles.header}>
      <div className={styles.logoSize}>
        <Link to="/dashboard">
          <img src="/assets/images/Logo.png" alt="logo" className="w-full" />
        </Link>
      </div>

      <div className={styles.headerMenu}>
        {props.isAuthLayout || location.pathname === "/admin/dashboard"
          ? langOptions.map((option, index) => (
              <button
                key={index}
                className={styles.langOption}
                style={{
                  border: index === 2 ? "none" : "",
                  textDecoration:
                    userLanguage === option?.value ? "underline" : "",
                }}
                onClick={() => {
                  userLanguageChange(option.value as any);
                  localStorage.setItem("rcml-lang", option.value as string);
                }}
              >
                {option.label}
              </button>
            ))
          : null}

        {!props.isAuthLayout && (
          <Dropdown overlay={menu} trigger={["click"]}>
            <div
              style={{
                cursor: "pointer",
                border: "1px solid #EEEEEE",
                padding: "2px",
                borderRadius: "100%",
                backgroundColor: "#FFF",
              }}
            >
              <Button
                icon={<FaUser size={20} />}
                type="text"
                className="headerProfileButton"
                style={{ borderRadius: "100%", color: "#727372" }}
              />
            </div>
          </Dropdown>
        )}
      </div>
    </div>
  );
}
